<template>
  <div class="doctor-maintain">
    <div class="btn-box">
      <div class="top-box">
        <span>当前医生维护来源：{{ info.type | typeText }}</span>
        <el-button type="primary"
                   size="small"
                   style="margin-left:20px"
                   :disabled=" module_id_array[0] ? !module_id_array.includes('1194') : false"
                   @click="editorSource">修改</el-button>
      </div>

    </div>
    <div class="between align-center">
      <div class="search-box"
           style="margin:0">
        <!-- 医生姓名 -->
        <div class="item">
          <span>医生姓名</span>
          <div class="item-content">
            <el-input v-model="searchForm.doctor_name"
                      size="small"
                      clearable
                      @keyup.enter.native="seachEnterFun"></el-input>
          </div>
        </div>

        <!-- 手机号 -->
        <div class="item">
          <span>手机号</span>
          <div class="item-content">
            <el-input v-model="searchForm.phone"
                      size="small"
                      clearable
                      @keyup.enter.native="seachEnterFun"></el-input>
          </div>
          <el-button type="primary"
                     size="small"
                     style="margin-left:20px"
                     @click="getList">查询</el-button>
          <el-button size="small"
                     @click="restBtn">重置</el-button>
        </div>
      </div>

      <el-button v-if="info.type == 1"
                 type="primary"
                 size="small"
                 style="margin-bottom:6px"
                 :disabled=" module_id_array[0] ? !module_id_array.includes('1191') : false"
                 @click="addFreeBtn">
        添加医生
      </el-button>

      <div v-if="info.type == 2">
        <span>当前标签:&nbsp;{{currentTag}}</span>
        <el-button type="primary"
                   size="small"
                   style="margin-left:20px"
                   :disabled=" module_id_array[0] ? !module_id_array.includes('1194') : false"
                   @click="editorTag">
          编辑标签
        </el-button>
      </div>
    </div>

    <div style="border: solid 1px #c9cbd6;">
      <el-table v-loading='tableLoading'
                :data="tableData"
                border=""
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }">
        <el-table-column v-for="item in tableHeader"
                         :key="item.prop"
                         :prop="item.prop"
                         :align="item.align"
                         :label="item.label"
                         :width="item.width"
                         :fixed="item.fixed">
          <template slot-scope="scope">
            <div v-if="item.prop == 'is_free'">
              {{ scope.row[item.prop] | freeText }}
            </div>
            <div v-else-if="item.prop == 'start_time'">
              {{ scope.row[item.prop] | dateFormat }}
            </div>
            <div v-else-if="item.prop == 'period'">
              {{ scope.row[item.prop] | periodText }}
            </div>
            <div v-else-if="item.prop == 'end_time'">
              {{ scope.row[item.prop] | dateFormat }}
            </div>
            <div v-else>{{ !scope.row[item.prop] ? '' : scope.row[item.prop] }}</div>
          </template>
        </el-table-column>

        <el-table-column v-if="info.type == 1"
                         label="操作"
                         align="center"
                         fixed="right">
          <template slot-scope="scope">
            <el-button type="text"
                       size="medium"
                       :disabled=" module_id_array[0] ? !module_id_array.includes('1190') : false"
                       @click="delBtn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="totalNum>0"
                  :total="totalNum"
                  :page.sync="pagination.page"
                  :limit.sync="pagination.pageNumber"
                  @pagination="getList" />
    </div>
    <!-- 修改维护来源 -->
    <!-- <el-dialog title="修改医生维护来源"
               :visible.sync="sourceVisible"
               width="600px"
               :close-on-click-modal="false">
      <div style="text-align:left;padding:20px;">
        <el-form :model="diaSourceForm"
                 ref="diaSourceRef"
                 label-width="100px"
                 class="visibilityVisible-ruleForm">
          <div class="cases-box">
            <el-form-item label="医生维护来源"
                          prop="doctor_from">
              <el-radio-group v-model="diaSourceForm.doctor_from">
                <el-radio :label="1">自定义添加医生</el-radio>
                <el-radio :label="2">按标签添加医生</el-radio>
              </el-radio-group>
            </el-form-item>

          </div>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="sourceVisible=false"
                   size="medium"
                   plain>取 消</el-button>
        <el-button type="primary"
                   size="medium"
                   @click="diaSourceRefConfirm('diaSourceRef')">确 定</el-button>
      </span>
    </el-dialog> -->

    <el-dialog title="修改医生维护来源"
               :visible.sync="sourceVisible"
               width="600px"
               :close-on-click-modal="false">
      <div style="text-align:left;padding:20px">
        <el-form :model="diaSourceForm"
                 :rules="rules"
                 ref="diaSourceFormRef"
                 label-width="100px"
                 class="demo-diaSourceForm">

          <el-form-item label="医生来源"
                        prop="doctor_from">
            <el-radio-group v-model="diaSourceForm.doctor_from"
                            @change="changeDoctorFrom">
              <el-radio :label="1">自定义添加医生</el-radio>
              <el-radio :label="2">按标签添加医生</el-radio>
            </el-radio-group>
          </el-form-item>

          <template v-if="diaSourceForm.doctor_from==2">
            <el-form-item label="标签类型"
                          prop="label_from">
              <el-radio-group v-model="diaSourceForm.label_from"
                              @change="changeLabelFrom">
                <!-- <el-radio :label="2">手动标签</el-radio> -->
                <el-radio :label="3">自动标签</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="标签"
                          prop="platform_label_id">
              <el-select v-model="diaSourceForm.label_category_type"
                         placeholder="请选择"
                         style="width:200px"
                         @change="changeLabel"
                         size="small">
                <el-option v-for="item in labelTypeList"
                           :key="item.label_type"
                           :label="item.label_type_name"
                           :value="item.label_type">
                </el-option>
              </el-select>
              <el-select v-if="diaSourceForm.label_category_type != ''"
                         v-model="diaSourceForm.platform_label_id"
                         placeholder="请选择"
                         style="width:200px;margin-left:10px"
                         size="small">
                <el-option v-for="item in labelList"
                           :key="item.label_id"
                           :label="item.label_name"
                           :value="item.label_id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>

        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   plain
                   @click="cancelSource">取 消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="confirmSource('diaSourceFormRef')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择推荐医生弹框 -->
    <el-dialog title="请选择需要添加的医生"
               width="80%"
               custom-class="freeClinicPatient-freeDoctorTableDia"
               :visible.sync="freeDoctorTableDia">
      <div class="content-box">
        <div class="search-box">
          <!-- 医生姓名 -->
          <div class="item">
            <span>医生姓名</span>
            <div class="item-content">
              <el-input v-model="freeDoctorForm.doctor_name"
                        size="small"
                        clearable
                        @keyup.enter.native="seachEnterFun"></el-input>
            </div>
          </div>

          <!-- 手机号 -->
          <div class="item">
            <span>医生手机号</span>
            <div class="item-content">
              <el-input v-model="freeDoctorForm.phone"
                        size="small"
                        clearable
                        @keyup.enter.native="seachEnterFun"></el-input>
            </div>
            <el-button type="primary"
                       size="small"
                       style="margin-left:20px"
                       @click="getFreeDoctor">查询</el-button>
          </div>
        </div>
        <el-table v-loading="diaTableLoading"
                  :data="freeDoctorTable"
                  tooltip-effect="dark"
                  height="400px"
                  :header-cell-style="{ background: '#F5F5F5' }"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="55">
          </el-table-column>
          <el-table-column v-for="item in diaTableHeader"
                           :key="item.prop"
                           :prop="item.prop"
                           :label="item.label"
                           :width="item.width"
                           :align="item.align"
                           :fixed="item.fixed">
            <template slot-scope="scope">
              <div v-if="item.prop == 'is_free'">
                {{ scope.row[item.prop] | freeText }}
              </div>
              <div v-else-if="item.prop == 'start_time'">
                {{ scope.row[item.prop] | dateFormat }}
              </div>
              <div v-else-if="item.prop == 'period'">
                {{ scope.row[item.prop] | periodText }}
              </div>
              <div v-else-if="item.prop == 'end_time'">
                {{ scope.row[item.prop] | dateFormat }}
              </div>
              <div v-else>{{ !scope.row[item.prop] ? '' : scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="between align-center">
          <pagination v-show="diaTotalNum>0"
                      :total="diaTotalNum"
                      :page.sync="diaPagination.page"
                      :limit.sync="diaPagination.pageNumber"
                      @pagination="getFreeDoctor" />
          <div style="padding-top: 22px;">
            <el-button size="small"
                       @click="freeDoctorTableDia = false">取 消</el-button>
            <el-button size="small"
                       type="primary"
                       @click="confirmDoctor">确 定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 编辑标签 -->
    <el-dialog title="编辑标签"
               :visible.sync="tagVisible"
               width="600px"
               :close-on-click-modal="false">
      <div style="text-align:left;padding:20px;">
        <el-form :model="diaTagForm"
                 label-width="100px">
          <div class="cases-box">
            <el-form-item label="标签分类"
                          prop="label_category_id">
              <el-select v-model="diaTagForm.label_category_id"
                         size="small"
                         placeholder="请选择标签分类"
                         @change="changeLabelCategory">
                <el-option v-for="item in labelCategoryOptions"
                           :key="item.label_category_id"
                           :label="item.label_category_name"
                           :value="item.label_category_id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="标签名"
                          prop="label_id">
              <el-select v-model="diaTagForm.label_id"
                         size="small"
                         placeholder="请选择标签名">
                <el-option v-for="item in freeLabelOptions"
                           :key="item.label_id"
                           :label="item.label_name"
                           :value="item.label_id"></el-option>
              </el-select>
            </el-form-item>

          </div>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="tagVisible=false"
                   size="medium"
                   plain>取 消</el-button>
        <el-button type="primary"
                   size="medium"
                   :disabled=" module_id_array[0] ? !module_id_array.includes('1194') : false"
                   @click="diaTagConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import department from '@/api/department.js';
import Pagination from '@/components/Pagination/index';
import common from '@/api/common.js';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      searchForm: {
        doctor_name: '',
        phone: ''
      },
      tableHeader: [
        {
          label: '医生姓名',
          prop: 'doctor_name',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '手机号',
          prop: 'phone',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '医院名称',
          prop: 'hospital',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '科室',
          prop: 'department_name',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '职称',
          prop: 'title',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '是否开启义诊',
          prop: 'is_free',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '义诊开启时间',
          prop: 'start_time',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '义诊名额',
          prop: 'number',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '义诊周期',
          prop: 'period',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '义诊结束时间',
          prop: 'end_time',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      tableData: [],
      info: {
        type: '',
        label_name: '',
        label_id: '',
        label_category_name: '',
        label_category_id: ''
      },

      freeDoctorForm: {
        doctor_name: '',
        phone: ''
      },
      freeDoctorTableDia: false,
      diaTotalNum: 0,
      diaPagination: {
        page: 1,
        pageNumber: 10
      },
      diaTableLoading: false,
      diaTableHeader: [
        {
          label: '医生姓名',
          prop: 'doctor_name',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '手机号',
          prop: 'phone',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '医院名称',
          prop: 'hospital',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '是否开启义诊',
          prop: 'is_free',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '义诊开启时间',
          prop: 'start_time',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '义诊名额',
          prop: 'number',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '义诊周期',
          prop: 'period',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '义诊结束时间',
          prop: 'end_time',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      freeDoctorTable: [],
      multipleSelection: [],
      tagVisible: false,
      diaTagForm: {
        label_category_id: '',
        label_id: ''
      },
      labelCategoryOptions: [],
      freeLabelOptions: [],
      sourceVisible: false,
      diaSourceForm: {
        free_id: '',
        doctor_from: '',
        label_from: 3,
        platform_label_id: '',
        label_category_type: ''
      },
      labelTypeList: [],
      labelList: [],
      rules: {
        doctor_from: [{ required: true, message: '请选择', trigger: 'change' }],
        label_from: [{ required: true, message: '请选择', trigger: 'change' }],
        platform_label_id: [
          { required: true, message: '请选择', trigger: 'change' }
        ]
      }
    };
  },
  filters: {
    typeText(val) {
      switch (val) {
        case 1:
          return '自定义添加医生';
        case 2:
          return '标签添加医生';
      }
    },
    freeText(val) {
      switch (val) {
        case 1:
          return '是';
        case 0:
          return '否';
      }
    },
    periodText(val) {
      switch (val) {
        case 0:
          return '仅本次';
        case 1:
          return '每一周';
        case 2:
          return '每两周';
        case 3:
          return '每三周';
        case 4:
          return '每四周';
      }
    },
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:ss');
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
    currentTag() {
      let { label_category_id, label_category_name, label_id, label_name } =
        this.info;
      if (label_category_id == '' || !label_category_id) {
        return `未分类`;
      }
      {
        return `${label_category_name}/${label_name}`;
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      let params = Object.assign(
        {},
        this.pagination,
        this.searchForm,
        this.routeQuery
      );
      department.freeDoctorList(params).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          let {
            type,
            label_name,
            label_id,
            label_category_name,
            label_category_id,
            list,
            total
          } = data;
          this.info = {
            type,
            label_name,
            label_id,
            label_category_id,
            label_category_name
          };
          this.diaSourceForm.doctor_from = type;
          this.tableData = list;
          this.totalNum = total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      let keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    restBtn() {
      for (let key in this.searchForm) {
        this.searchForm[key] = '';
      }
      this.getList();
    },
    editorSource() {
      this.diaSourceForm.doctor_from = this.info.type;
      this.sourceVisible = true;
      if (this.diaSourceForm.doctor_from == 2) {
        this.getLabelType();
      }
    },
    diaSourceRefConfirm() {
      const loading = this.$loading();
      let params = Object.assign({}, this.diaSourceForm, this.routeQuery);
      department
        .editFreeDoctorGroupSource(params)
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success('编辑成功');
            this.getList();
            this.sourceVisible = false;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    delBtn(row) {
      let { doctor_id } = row;
      this.$confirm('确认删除该医生？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let params = Object.assign({ doctor_id }, this.routeQuery);
          const loading = this.$loading();
          department
            .deleteFreeDoctor(params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success('删除成功');
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    addFreeBtn() {
      this.freeDoctorTableDia = true;
      this.multipleSelection = [];
      this.getFreeDoctor();
    },
    // 选择自定义医生
    getFreeDoctor() {
      this.diaTableLoading = true;
      let params = Object.assign({}, this.diaPagination, this.freeDoctorForm);
      department
        .getFreeDoctor(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.freeDoctorTable = data.list;
            this.diaTotalNum = data.total;
          }
          this.diaTableLoading = false;
        })
        .catch((err) => {
          this.diaTableLoading = false;
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    confirmDoctor() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择医生');
        return;
      }
      let doctor_id = this.multipleSelection.map((item) => item.doctor_id);
      let params = {
        free_id: this.routeQuery.free_id,
        doctor_id
      };
      const loading = this.$loading();
      department
        .addFreeDoctor(params)
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success('添加成功');
            this.getList();
            this.freeDoctorTableDia = false;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 编辑标签
    editorTag() {
      let { label_category_id, label_id } = this.info;
      this.diaTagForm.label_category_id = label_category_id;
      this.diaTagForm.label_id = label_id;
      const loading = this.$loading();
      this.getFreeLabelCategory().then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.labelCategoryOptions = data;
          this.tagVisible = true;
          if (label_category_id && label_category_id != '') {
            this.getFreeLabel()
              .then((res) => {
                let { code, data } = res;
                if (code === 0) {
                  this.freeLabelOptions = data;
                }
                loading.close();
              })
              .catch((err) => {
                loading.close();
              });
          } else {
            loading.close();
          }
        }
      });
    },
    // 获取标签分类
    getFreeLabelCategory() {
      return new Promise((resolve, reject) => {
        department
          .getFreeLabelCategory()
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 获取标签名
    getFreeLabel() {
      return new Promise((resolve, reject) => {
        department
          .getFreeLabel({
            label_category_id: this.diaTagForm.label_category_id
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    changeLabelCategory() {
      const loading = this.$loading();
      this.diaTagForm.label_id = '';
      this.getFreeLabel()
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.freeLabelOptions = data;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    diaTagConfirm() {
      for (let key in this.diaTagForm) {
        if (this.diaTagForm[key] == '') {
          this.$message.warning('请选择');
          return;
        }
      }
      const loading = this.$loading();
      let params = Object.assign({}, this.routeQuery, this.diaTagForm);
      department
        .editFreeLabel(params)
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success('编辑成功');
            this.getList();
            this.tagVisible = false;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },

    // //////
    editDoctorSource(params) {
      department.editFreeDoctorGroupSource(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success('修改成功');
          this.getList();
          this.sourceVisible = false;
        }
      });
    },
    cancelSource() {
      this.sourceVisible = false;
    },
    confirmSource(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = _.pick(
            this.diaSourceForm,
            'free_id',
            'doctor_from',
            'label_from',
            'label_category_type',
            'platform_label_id'
          );
          params.label_from = params.label_from == 2 ? 1 : 2;
          params.free_id = this.$route.query.free_id;
          this.editDoctorSource(params);
        }
      });
    },
    changeLabel(value) {
      this.getLabel();
      this.diaSourceForm.platform_label_id = '';
      this.$nextTick(() => {
        this.$refs['diaSourceFormRef'].clearValidate();
      });
    },
    changeDoctorFrom(value) {
      if (value == 2) {
        if (!this.diaSourceForm.label_from) {
          this.diaSourceForm.label_from = 2;
        }
        this.diaSourceForm.platform_label_id = '';
        this.$nextTick(() => {
          this.$refs['diaSourceFormRef'].clearValidate();
        });
        this.getLabelType();
      }
    },
    changeLabelFrom(value) {
      this.diaSourceForm.platform_label_id = '';
      this.diaSourceForm.label_category_type = '';
      this.getLabelType();
      this.$nextTick(() => {
        this.$refs['diaSourceFormRef'].clearValidate();
      });
    },
    getLabelType() {
      return new Promise(async (resolve) => {
        let params = {
          type: this.diaSourceForm.label_from
        };
        // params.type = params.type == 1 ? 2 : 3;
        let { data } = await common.getLabelType(params);
        this.labelTypeList = data.list;
        if (this.diaSourceForm.label_category_type == 0) {
          this.diaSourceForm.label_category_type = data.list[0].label_type;
          this.diaSourceForm.platform_label_id = '';
          this.$nextTick(() => {
            this.$refs['diaSourceFormRef'].clearValidate();
          });
        }
        resolve(data);
        this.getLabel();
      });
    },
    getLabel() {
      return new Promise(async (resolve) => {
        let params = {
          type: this.diaSourceForm.label_from,
          label_type: this.diaSourceForm.label_category_type
        };

        let { data } = await common.getLabel(params);
        this.labelList = data.list;
        resolve(data);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.freeClinicPatient-freeDoctorTableDia {
  .content-box {
    padding: 20px !important;
  }
}
.search-box {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  .item {
    height: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    span {
      display: inline-block;
      width: 80px;
      margin-right: 4px;
      text-align: right;
      white-space: nowrap;
      box-sizing: border-box;
    }
  }
  .item-content {
    // width: 100%;
    .el-date-editor {
      width: 100%;
    }
    .el-radio-group {
      padding-top: 4px;
    }
  }
}
.doctor-maintain {
  .btn-box {
    padding-left: 24px;
    .top-box {
      margin-bottom: 4px;
    }
  }
}
</style>